// @flow
// issuance types
const API = process.env.API || ""
export const PRIVATE = 'Non-Commercial';
export const COMMERCIAL = 'Commercial';
export const QUEUING_LOTTERY_RANGE_FORMAT = 'ddd, MMM D, YYYY';
export const EAP_TIME_ZONE = 'America/New_York';
export const CANCEL_ENDPOINT = (inventoryId: string, entryId: string) => `${API}/queuelottery/lottery/${inventoryId}/application/${entryId}/cancel`;

export const PROGRESS_INDICATOR_STEPS = [
    'Order Details',
    'Review Cart',
    'Payment',
    'Confirmation',
];

function makeReversedDictionary(dic) {
    const newDic = {}
    Object.keys(dic).forEach((k) => {
      const v = dic[k]
      newDic[v] = k
    })
    return newDic;
}

export const QUEUING_LOTTERY_STATUS: { [statusName: string]: number } = {
    Drafted: 0,
    Displayed: 1,
    Open: 2,
    Closed: 3,
    Executing: 4,
    Executed: 5,
    Notified: 6,
    Archived: 7,
}

export const QUEUING_LOTTERY_STATUS_LABEL: { [statusNumber: number]: string } = makeReversedDictionary(QUEUING_LOTTERY_STATUS)

export const QUEUING_LOTTERY_APPLICATION_STATUS = {
    InProgress: "In Progress",
    Applied: "Applied",
    Won: "Won",
    Lost: "Lost",
    Cancelled: "Cancelled",
    Voided: "Voided",
}